/* istanbul ignore file
Tested in the child components - navigation-rail and navigation-bar
*/
import { state } from 'lit-element'
import { getShellApiInstance } from '../../../common/shell-api-helpers'
import { ShellElement } from '../../../common/shell-element'
import { type BadgeNumberEvent } from '../../../services/badge-numbers'
import { type I18NEvents, I18NNamespace } from '../../../services/i18n'
import { getEventBus } from '../../../services/namespaces'
import { ShellNamespace, type shellEvents } from '../../../services/shell-namespace'
import { type InternalNavigationLink } from '../types'
import { updateLinksAfterBadgeEvent } from '../utils'

export class GoToBaseNavigation extends ShellElement {
  @state() visibleLinks: InternalNavigationLink[] = []
  private unsubscribeBadgeEvents: (() => void)[] = []

  connectedCallback() {
    super.connectedCallback()
    this.subscribeToRouteChangeEvent()
    this.subscribeToLocaleChangeEvent()
  }

  private subscribeToRouteChangeEvent(): void {
    const { routeChanged } = getEventBus().subscribeTo<typeof ShellNamespace, typeof shellEvents>(ShellNamespace)
    routeChanged.on(this.rerenderNavrail)
    this.unsubscribeFunctions.push(() => routeChanged.removeListener(this.rerenderNavrail))
  }

  private subscribeToLocaleChangeEvent(): void {
    const { localeChanged } = getEventBus().subscribeTo<typeof I18NNamespace, typeof I18NEvents>(I18NNamespace)
    localeChanged.on(this.rerenderNavrail)
    this.unsubscribeFunctions.push(() => localeChanged.removeListener(this.rerenderNavrail))
  }

  protected subscribeToBadgeEvent(): void {
    this.unsubscribeFromAllBadgeEvents()
    const badgeNumbers = getShellApiInstance().badgeNumbers
    this.visibleLinks.map(link => {
      const listener = (event: BadgeNumberEvent) => {
        this.handleNavigationBadgeEvent(event.value, link.id)
      }
      badgeNumbers.addEventListener('change', listener, { id: link.id, showInNavigation: true })
      this.unsubscribeBadgeEvents.push(() => {
        badgeNumbers.removeEventListener('change', listener)
      })
    })
  }

  private unsubscribeFromAllBadgeEvents() {
    this.unsubscribeBadgeEvents.forEach(unsubscribe => unsubscribe())
    this.unsubscribeBadgeEvents = []
  }

  private readonly handleNavigationBadgeEvent = (value: number, id: string | undefined): void => {
    this.visibleLinks = updateLinksAfterBadgeEvent(value, id, this.visibleLinks)
  }

  private readonly rerenderNavrail = () => {
    this.requestUpdate()
  }

  disconnectedCallback(): void {
    super.disconnectedCallback()
    this.unsubscribeFromAllBadgeEvents()
  }
}
